import { h } from "@stencil/core";
import { isBreakpointSmaller } from "../../../utils";
export class DcUiHeaderBurger {
    constructor() {
        this.open = false;
        this.iconSize = this.getIconSize();
        this.handleResize = () => {
            this.iconSize = this.getIconSize();
        };
        this.handleClick = () => {
            this.open = !this.open;
            this.dcHeaderBurgerClick.emit(this.open);
        };
    }
    async dcToggleBurger() {
        this.open = !this.open;
    }
    componentDidLoad() {
        window.addEventListener('resize', this.handleResize);
    }
    disconnectedCallback() {
        window.removeEventListener('resize', this.handleResize);
    }
    getIconSize() {
        return isBreakpointSmaller('md') ? 'medium' : 'large';
    }
    render() {
        return (h("button", { key: 'd9b064b4b78f9adea1240a4a8bf33b4e3fdca0e9', onClick: this.handleClick, "aria-label": this.label }, h("dc-ui-icon", { key: '813e9638a7a336dbe85442d4da380aadba8fbcf0', name: this.open ? 'dc_close' : 'dc_list_mobile', size: this.iconSize })));
    }
    static get is() { return "dc-ui-header-burger"; }
    static get encapsulation() { return "shadow"; }
    static get originalStyleUrls() {
        return {
            "$": ["dc-ui-header-burger.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["dc-ui-header-burger.css"]
        };
    }
    static get properties() {
        return {
            "open": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "open",
                "reflect": true,
                "defaultValue": "false"
            },
            "label": {
                "type": "string",
                "mutable": false,
                "complexType": {
                    "original": "string",
                    "resolved": "string",
                    "references": {}
                },
                "required": false,
                "optional": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "getter": false,
                "setter": false,
                "attribute": "label",
                "reflect": false
            }
        };
    }
    static get states() {
        return {
            "iconSize": {}
        };
    }
    static get events() {
        return [{
                "method": "dcHeaderBurgerClick",
                "name": "dcHeaderBurgerClick",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": ""
                },
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                }
            }];
    }
    static get methods() {
        return {
            "dcToggleBurger": {
                "complexType": {
                    "signature": "() => Promise<void>",
                    "parameters": [],
                    "references": {
                        "Promise": {
                            "location": "global",
                            "id": "global::Promise"
                        }
                    },
                    "return": "Promise<void>"
                },
                "docs": {
                    "text": "",
                    "tags": []
                }
            }
        };
    }
}
//# sourceMappingURL=dc-ui-header-burger.js.map
